import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { isExternal } from '../utils'

export default /*#__PURE__*/_defineComponent({
  props: ['to', 'target'],
  setup(__props) {

const props = __props

const type = computed(() => {
  return isExternal(props.to) ? 'a' : 'router-link'
})

const linkProps = (to:string) => {
  if (isExternal(props.to)) {
    return {
      href: to,
      rel: 'noopener',
      target: props.target
    }
  } else {
    return {
      to: to,
      target: props.target
    }
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(type)), _normalizeProps(_guardReactiveProps(linkProps(__props.to))), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16))
}
}

})